import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  getMandatoryFields,
  getValidationErrors,
} from '../../../../OnBoarding/Organization/utils/userOnboarding/userOnboarding.util';
import { isEmpty } from 'lodash';
import { Box } from '@mui/material';
import CircularLoader from '../../../../../atoms/CircularLoader/circular-loader';
import {
  LoadingStatus,
  toastMessage,
  ToastThemes,
} from '../../../../../constants/common';
import ActionHeader from '../../../../OnBoarding/Organization/ActionHeader/ActionHeader';
import FormEdit from '../../../../OnBoarding/common/Form/FormEdit';
import useDidMountEffect from '../../../../../customHooks/useDidMountEffect';
import { GeoTagging } from '../../../../../services/geoTagging';
import { showToast } from '../../../../../utils/common.util';
import {
  stringSubstitute,
  ToastMessages,
} from '../../../../OnBoarding/Organization/constants/onboarding.constants';
import { useDispatch } from 'react-redux';
import { fetchLogo } from '../../../../../redux/onboarding/action';

const TDSConfigFormEdit = (props) => {
  const {
    setViewMode,
    formConfig,
    isNew,
    formData,
    setFormInfo,
    formInfo,
    idForDetails,
  } = props;

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(-1);

  const [disabledSave, setDisabledSave] = useState(true);

  useDidMountEffect(() => {
    setDisabledSave(false);
  }, [formInfo]);

  const handleDiscard = () => {
    if (isNew) {
      navigate(-1);
    } else {
      setViewMode(true);
    }
  };

  const requiredFields = useMemo(() => {
    return getMandatoryFields(formConfig);
  }, [formConfig]);

  const handleSave = async () => {
    const errors = getValidationErrors(formInfo, requiredFields);
    if (isEmpty(errors)) {
      setLoading(LoadingStatus.Loading);
      await new GeoTagging()
        .tdsConfigUpdate(formInfo)
        .then(async (res) => {
          showToast(
            ToastMessages.success.replace(
              stringSubstitute,
              toastMessage.success
            ),
            ToastThemes.success
          );
          dispatch(fetchLogo());
          // await new GeoTagging()
          //   .tdsConfigDetails(idForDetails)
          //   .then((res) => {
          //     setFormInfo(res);
          //     setLoading(LoadingStatus.Success);
          //   })
          //   .catch((err) => {
          //     showToast(err?.response?.data?.message, ToastThemes.error);
          //     setLoading(LoadingStatus.Failure);
          //     throw err?.response?.data?.message;
          //   });
          setViewMode(true);
          setLoading(LoadingStatus.Success);
        })
        .catch((err) => {
          showToast(err?.response?.data?.message, ToastThemes.error);
          setLoading(LoadingStatus.Failure);
          throw err?.response?.data?.message[0];
        });
    } else {
      setValidationErrors(errors);
    }
  };

  return (
    <Box>
      <CircularLoader show={loading === LoadingStatus.Loading} />
      <Box mb={3} mx={-3} mt={-3}>
        <ActionHeader
          labelText={formData?.name || 'TDS Config'}
          showDiscard
          showPublish
          showPublishModal={false}
          publishButtonText="Save"
          onPublishClick={handleSave}
          onClickDiscard={handleDiscard}
          showSave={false}
          disabledPublish={disabledSave}
        />
      </Box>
      <FormEdit
        list={formConfig}
        formInfo={formInfo}
        setFormData={setFormInfo}
        errors={validationErrors}
        setErrors={setValidationErrors}
      />
    </Box>
  );
};

export default TDSConfigFormEdit;
